import React from 'react';
import { makeStyles } from '@mui/styles';
import { WithChildrenProps } from '..';

const useStyles = makeStyles({
    root: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'block',
        flex: 1,
        minWidth: 0,
        fontSize: 14,
        userSelect: 'none',
        msUserSelect: 'none',
        MozUserSelect: '-moz-none',
        WebkitUserSelect: 'none',
        '& a:visited, & a:hover, & a:link': {
            color: 'inherit',
            textDecoration: 'none'
        }
    }
}, { name: 'TreeNodeName' });

const TreeNodeName: React.FunctionComponent<WithChildrenProps> = ({ children }) => {
    const classes = useStyles();
    return <span className={classes.root}>{children}</span>
}

export default TreeNodeName;